import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'ms-my',
  Pagination: {
    items_per_page: '/ halaman',
    jump_to: 'Lompat ke',
    jump_to_confirm: 'Sahkan',
    page: '',
    prev_page: 'Halaman sebelumnya',
    next_page: 'Halam seterusnya',
    prev_5: '5 halaman sebelum',
    next_5: '5 halaman seterusnya',
    prev_3: '3 halaman sebelumnya',
    next_3: '3 halaman seterusnya',
  },
  DatePicker: {
    lang: {
      placeholder: 'Pilih tarikh',
      rangePlaceholder: [
        'Tarikh mula',
        'Tarikh akhir',
      ],
      locale: 'ms_MY',
      today: 'Hari ini',
      now: 'Sekarang',
      backToToday: 'Kembali ke hari ini',
      ok: 'Ok',
      timeSelect: 'Pilih masa',
      dateSelect: 'Pilih tarikh',
      weekSelect: 'Pilih minggu',
      clear: 'Padam',
      month: 'Bulan',
      year: 'Tahun',
      previousMonth: 'Bulan lepas',
      nextMonth: 'Bulan depan',
      monthSelect: 'Pilih bulan',
      yearSelect: 'Pilih tahun',
      decadeSelect: 'Pilih dekad',
      yearFormat: 'YYYY',
      dayFormat: 'D',
      dateFormat: 'M/D/YYYY',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      previousYear: 'Tahun lepas (Ctrl+left)',
      nextYear: 'Tahun depan (Ctrl+right)',
      previousDecade: 'Dekad lepas',
      nextDecade: 'Dekad depan',
      previousCentury: 'Abad lepas',
      nextCentury: 'Abad depan',
    },
    timePickerLocale: {
      placeholder: 'Sila pilih masa',
    },
  },
  TimePicker: {
    placeholder: 'Sila pilih masa',
  },
  Calendar: {
    lang: {
      placeholder: 'Pilih tarikh',
      rangePlaceholder: [
        'Tarikh mula',
        'Tarikh akhir',
      ],
      locale: 'ms_MY',
      today: 'Hari ini',
      now: 'Sekarang',
      backToToday: 'Kembali ke hari ini',
      ok: 'Ok',
      timeSelect: 'Pilih masa',
      dateSelect: 'Pilih tarikh',
      weekSelect: 'Pilih minggu',
      clear: 'Padam',
      month: 'Bulan',
      year: 'Tahun',
      previousMonth: 'Bulan lepas',
      nextMonth: 'Bulan depan',
      monthSelect: 'Pilih bulan',
      yearSelect: 'Pilih tahun',
      decadeSelect: 'Pilih dekad',
      yearFormat: 'YYYY',
      dayFormat: 'D',
      dateFormat: 'M/D/YYYY',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      previousYear: 'Tahun lepas (Ctrl+left)',
      nextYear: 'Tahun depan (Ctrl+right)',
      previousDecade: 'Dekad lepas',
      nextDecade: 'Dekad depan',
      previousCentury: 'Abad lepas',
      nextCentury: 'Abad depan',
    },
    timePickerLocale: {
      placeholder: 'Sila pilih masa',
    },
  },
  global: {
    placeholder: 'Sila pilih',
  },
  PageHeader: {
    back: 'Kembali',
  },
  Text: {
    edit: 'Sunting',
    copy: 'Salin',
    copied: 'Berjaya menyalin',
    expand: 'Kembang',
  },
  Empty: {
    description: 'Tiada data',
  },
  Table: {
    filterTitle: 'Cari dengan tajuk',
    filterConfirm: 'OK',
    filterReset: 'Menetapkan semula',
    emptyText: 'Tiada data',
    selectAll: 'Pilih semua',
    selectInvert: 'Terbalikkan',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Batal',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Batal',
  },
  Transfer: {
    notFoundContent: 'Tidak dijumpai',
    searchPlaceholder: 'Carian di sini',
    itemUnit: 'item',
    itemsUnit: 'item',
  },
  Icon: {
    icon: 'ikon',
  },
  Select: {
    notFoundContent: 'Tidak Dijumpai',
  },
  Upload: {
    uploading: 'Sedang memuat naik...',
    removeFile: 'Buang fail',
    uploadError: 'Masalah muat naik',
    previewFile: 'Tengok fail',
    downloadFile: 'Muat turun fail',
  },
};

export default localeValues;
